<template>
  <div class="sidebar" 
  :style="sidebarStyle" 
  :data-color="backgroundColor"
   >
    <div class="sidebar-wrapper">
      <div class="logo">
        <a href="/admin/inspections" class="justify-content-center simple-text logo__container">


          <img src="../../../public/LogopricipalChami.png" style="width:100px; background-color: white; border-radius: 50px;">
        </a>

      </div>

      <slot name="content"></slot>
      <ul class="nav nav-main__links">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link v-for="(link, index) in sidebarLinks" :key="link.name + index" :to="link.path"
            @click="closeNavbar" :link="link">
            <i :class="link.icon"></i>
            <p>{{ link.name }}</p>
          </sidebar-link>
        </slot>
      </ul>
      <ul class="nav nav-bottom" v-if="$slots['bottom-links']">
        <slot name="bottom-links"></slot>
      </ul>
    </div>
  </div>
</template>
<script>
import SidebarLink from './SidebarLink.vue'

export default {
  components: {
    SidebarLink
  },
  props: {
    title: {
      type: String,
      default: 'Vue LBD'
    },
    backgroundColor: {
      type: String,
      default: '#F0C505',
      // validator: (value) => {
      //   let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black']
      //   return acceptedValues.indexOf(value) !== -1
      // }
    },
    backgroundImage: {
      type: String,
      default: '../../../img/atardecer.png'
    },
    activeColor: {
      type: String,
      default: 'success',
      // validator: (value) => {
      //   let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
      //   return acceptedValues.indexOf(value) !== -1
      // }
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    }
  },
  computed: {
    sidebarStyle() {
      return {
        // backgroundImage: `url(${this.backgroundImage})`
        // backgroundColor:'red',
      }
    }
  }
}

</script>
<style>
.sidebar .sidebar-wrapper {
  display: flex;
  flex-direction: column;
}

.sidebar .nav-main__links {
  flex: 1;
}

.sidebar .sidebar-wrapper .logo .logo__container {
  padding-left: 10px;
}

.sidebar {
  background-color: var(--backgroundColor, #F0C505); /* Valor predeterminado o valor personalizado */
}

/* Ajusta el color activo según la propiedad activeColor */
.sidebar .nav-main__links i.success {
  color: var(--activeColor, #F0C505); /* Valor predeterminado o valor personalizado */
}

</style>
